import React, { useCallback } from "react";
import { MainTemplateWrapper, MainTemplateWrapperWithLogo } from "../../AdAssistant.styled";
import VideoImagePreview from "../video-image-preview/VideoImagePreview";
import LogoCompanyHeader from "../logo-company-header/LogoCompanyHeader";
import EditHoverLayer from "../edit-hover-layer/EditHoverLayer";
import { LogoCompanyHeaderContainer } from "./VerticalPreview.styled";
import UseDismissHoverLayer from "../use-dismiss-hover-layer/UseDismissHoverLayer";
import StatusIcon from "../status-icon/StatusIcon";
import { PreviewLocked } from "../../all-variants-modal/AllVariantsModal.styled";

const FALLBACK_LOGO = "/images/jobhappier.png";
const COMPANY_NAME = "Job Happier";

const VerticalPreview = ({
  id,
  isTemplateVideo,
  dimensionsPreview,
  templateInputProps,
  autoCroppingImage,
  orientationSelected,
  videoDuration,
  TemplateComponent,
  toggleEditionModal,
  toggleAdSelection,
  toggleAdSelectionEdition,
  setIsAdPreviewHovered,
  isAdPreviewHovered,
  isUsed,
  isDismissed,
  editedAd,
  userProfile
}) => {
  const handleMouseEnter = useCallback(() => {
    setIsAdPreviewHovered?.(true);
  }, [setIsAdPreviewHovered]);

  const handleMouseLeave = useCallback(() => {
    setIsAdPreviewHovered?.(false);
  }, [setIsAdPreviewHovered]);

  return (
    <MainTemplateWrapperWithLogo
      id={id}
      width={dimensionsPreview?.width}
      height={dimensionsPreview?.height}
    >
      {editedAd.isLocked && editedAd.lockedUserId !== userProfile.userId ? (
        <PreviewLocked width={dimensionsPreview?.width} height={dimensionsPreview?.height}>
          Locked by {editedAd.lockedBy}
        </PreviewLocked>
      ) : (
        <MainTemplateWrapper
          width={dimensionsPreview?.width}
          height={dimensionsPreview?.height}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <VideoImagePreview
            isTemplateVideo={isTemplateVideo}
            dimensionsPreview={dimensionsPreview}
            templateInputProps={templateInputProps}
            autoCroppingImage={autoCroppingImage}
            orientationSelected={orientationSelected}
            videoDuration={videoDuration}
            TemplateComponent={TemplateComponent}
          />

          <LogoCompanyHeaderContainer>
            <LogoCompanyHeader logoSrc={FALLBACK_LOGO} companyName={COMPANY_NAME} />
          </LogoCompanyHeaderContainer>

          {toggleEditionModal && (
            <EditHoverLayer
              isAdPreviewHovered={isAdPreviewHovered}
              toggleEditionModal={toggleEditionModal}
            />
          )}

          {toggleAdSelection && (
            <UseDismissHoverLayer
              isUsed={isUsed}
              isDismissed={isDismissed}
              isAdPreviewHovered={isAdPreviewHovered}
              toggleAdSelection={toggleAdSelection}
              toggleAdSelectionEdition={toggleAdSelectionEdition}
            />
          )}

          <StatusIcon isUsed={isUsed} isDismissed={isDismissed} isVertical={true} />
        </MainTemplateWrapper>
      )}
    </MainTemplateWrapperWithLogo>
  );
};

export default VerticalPreview;
